import { Component, AfterViewInit, ViewChild, OnInit } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RoutingService } from '../../services/routing.service';
import { BackendService } from '../../services/backend.service';
import { IWellRequestTable } from '../../model/well-request-table.model';

@Component({
    selector: 'app-well-request-table-all',
    templateUrl: './well-request-table-all.component.html',
    styleUrls: ['./well-request-table.component.css'],
    providers: [RoutingService],
    standalone: false
})
export class WellRequestTableAllComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<IWellRequestTable>();
  displayedColumns = ['id', 'country', 'operator', 'operatorId', 'rig', 'wellSource', 'rigSource', 'region', 'wellNumber', 'wellName', 'userName', 'date', 'status'];
  header: string = 'All Requests';

  totalCount = 0;
  pageIndex = 0;
  pageSize = 10;
  sortColumn = 'id';
  sortDirection: SortDirection = 'desc';
  searchText = '';
  appliedSearchText = '';

  constructor(private routingService: RoutingService, private backendService: BackendService) {
  }

  ngOnInit(): void {
    this.loadWells();
    this.activeRouteTab();
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sortState: Sort) => {
      this.sortColumn = sortState.active;
      this.sortDirection = sortState.direction || 'desc';
      this.pageIndex = 0;
      this.loadWells();
    });
  }

  loadWells(): void {
    const normalizedSearchText = this.searchText.trim();
    this.appliedSearchText = normalizedSearchText;

    if (normalizedSearchText) {
      this.backendService.searchWellRequestTable(normalizedSearchText, this.pageIndex, this.pageSize, this.sortColumn, this.sortDirection)
        .subscribe(result => {
          this.dataSource.data = result.items;
          this.totalCount = result.totalCount;
        });
    } else {
      this.backendService.getWellRequestTablePaged(this.pageIndex, this.pageSize, this.sortColumn, this.sortDirection)
        .subscribe(result => {
          this.dataSource.data = result.items;
          this.totalCount = result.totalCount;
        });
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadWells();
  }

  getRecord(row: IWellRequestTable) {
    this.routingService.forwardRedirect(row.id.toString(), row.currentStatusId);
  }

  activeRouteTab() { 
    this.routingService.setRoute(this.routingService.router.url);
  }

  applyFilter(event: KeyboardEvent) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchText = filterValue;

    if (event.key === 'Enter' || (!filterValue.trim() && !!this.appliedSearchText)) {
      this.pageIndex = 0;
      this.loadWells();
    }
  }
}
